import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { supportedContracts } from '../constants';
import { FaLessThan } from 'react-icons/fa';
export var Between = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'between',
    description: 'Check if amountIn is between minAmount and maxAmount',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                minAmount: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaLessThan }),
                minDecimals: new FctDecimals({}),
                maxAmount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                maxDecimals: new FctDecimals({}),
                amountIn: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaLessThan }),
                decimalsIn: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                description: 'amountIn - minAmount',
                innerIndex: 0,
            }),
        },
    }); },
});
